import { LegendPosition } from 'dashboard-engine/visualisations/components/Legends';

/**
 * Calculates the margins for the line graph based on the legend position and axis label visibility.
 * 
 * @param legendPosition - The position of the legend (auto, top, bottom, left, right, or undefined).
 * @param xAxisLabelVisible - Whether the X-axis label is visible.
 * @param yAxisLabelVisible - Whether the Y-axis label is visible.
 * @returns An object containing the top, right, bottom, and left margins.
 */
export const calculateMargins = (
    legendPosition: LegendPosition | undefined,
    xAxisLabelVisible: boolean,
    yAxisLabelVisible: boolean
) => {
    let margins = { top: 6, right: 25, bottom: 40, left: 30 };
    if (legendPosition === 'bottom') {
        margins.bottom = 60;
        if (!xAxisLabelVisible) {
            margins.bottom = 35;
        }
    } else if (xAxisLabelVisible) {
        margins.bottom = 60;
    }

    if (!yAxisLabelVisible) {
        margins.left = 10;
    }

    return margins;
};
